import { render, staticRenderFns } from "./Video_1.vue?vue&type=template&id=71a7efc6&"
import script from "./Video_1.vue?vue&type=script&lang=js&"
export * from "./Video_1.vue?vue&type=script&lang=js&"
import style0 from "./Video_1.vue?vue&type=style&index=0&id=71a7efc6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports